export default "__VITE_ASSET__Hh_OSBpL__"